import StarsIcon from './StarsIcon'

export default StarsIcon
